import React from "react"
import styles from "./face-scaler.module.css"
import { UV_INSERT_FACE_WIDTH_PX, useFaceScalerViewModel } from "./FaceScaler.vm"

type FaceScalerProps = {
  children?: React.ReactNode
  /** Width of the face being centred. Defaults to the 315px landscape insert. */
  faceWidth?: number
  className?: string
}

/**
 * Centres a fixed-width insert face in whatever panel it is given, shrinking it only when the
 * panel is narrower than the face itself.
 *
 * Used to drop the editable keepsake card into the piece visualiser's carousel, where the panel
 * is as wide as the modal on desktop and about a phone wide on mobile.
 */
export const FaceScaler = ({ children, faceWidth = UV_INSERT_FACE_WIDTH_PX, className = "" }: FaceScalerProps) => {
  const { panelRef, scale } = useFaceScalerViewModel({ faceWidth })

  return (
    <div ref={panelRef} className={`${styles["face-scaler"]} ${className}`.trim()}>
      <div
        data-face-scaler-face
        className={styles["face-scaler__face"]}
        style={scale < 1 ? { transform: `scale(${scale})` } : undefined}
      >
        {children}
      </div>
    </div>
  )
}
